import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-manage-monitoring',
  templateUrl: './manage-monitoring.component.html',
  styleUrls: ['./manage-monitoring.component.scss']
})
export class ManageMonitoringComponent implements OnInit {
  showmyFilter:boolean = false;
  showAddfacility:boolean = false;

  constructor(private dialog: MatDialog,) { }

  ngOnInit(): void {
  }

  showFilter(){
    this.showmyFilter = !this.showmyFilter
  }

 
  sendRequest(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{
      panelClass: 'selectParticipants',
    });
  }

  openCaseDetail(){
    this.showAddfacility = true;
  }
  
  getCloseAddfacility(message){
    this.showAddfacility = message;
  }

  getCloseFilter(message){
    this.showmyFilter = message;
  }

  close() {
    this.dialog.closeAll();
  }

  


}
